import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap'; // Uses Bootstrap styling

const ProjectIntroduction = () => {
  const navigate = useNavigate();

  const handleStartDemo = () => {
    navigate('/colormatch'); 
  };

  return (
    <div className="modal-content p-4 rounded shadow-sm" style={{ maxWidth: 600, margin: '40px auto' }}>
      <h2 className="text-center mb-3">Welcome to the Makeup Color Matcher Demo</h2>
      <p>
        This site is a functional demonstration of the color matching system I developed for my senior capstone project at UIUC.
        It is currently undergoing major changes to become a standalone platform with increased features and ongoing support.
      </p>
      <p>
        At this stage, my focus is on showcasing the core color matching functionality for others to try out.<br />
        <strong>Note:</strong> UI design aspects are in development—please excuse the minimal interface!
      </p>
      <p>
        I welcome any questions or suggestions. Please don’t hesitate to fill out the {' '}
  <a href="https://forms.gle/QE5FdXRdFMzTmWqN9" target="_blank" rel="noopener noreferrer">
    feedback form
  </a>{' '}to help shape future improvements.
      </p>
      <hr />
      <p className="text-muted">
        Thank you for your interest and patience during the development process.<br />
      </p>

      {/* Centered button */}
      <div className="d-flex justify-content-center mt-4">
        <Button style={{background:"#987284"}} size="lg" onClick={handleStartDemo}>
          Start Demo Now
        </Button>
      </div>
    </div>
  );
};

export default ProjectIntroduction;
